<div mat-dialog-title>
  <div *ngIf="customerDraft.id">Unternehmen bearbeiten</div>
  <div *ngIf="!customerDraft.id">Unternehmen hinzufügen</div>

</div>
<div mat-dialog-content>
  <mat-tab-group>
    <mat-tab label="Allgemein">
      <div class="flex flex-wrap -mx-2">
        <div class="px-2 w-full mb-3">
          <label>Markenname</label>
          <input type="text" class="styled dark" [(ngModel)]="customerDraft.companyDisplayName"/>
        </div>

        <div class="px-2 w-full mb-3">
          <label>Firma</label>
          <input type="text" class="styled dark" [(ngModel)]="customerDraft.companyName"/>
        </div>

        <div class="px-2 w-full mb-3">
          <label>USt.-ID</label>
          <input type="text" class="styled dark" [(ngModel)]="customerDraft.taxId"/>
        </div>

        <div class="px-2 w-full mb-3">
          <label>Registernummer</label>
          <input type="text" class="styled dark" [(ngModel)]="customerDraft.registerNumber"/>
        </div>

        <div class="px-2 w-full mb-3">
          <label>Website</label>
          <input type="text" class="styled dark" [(ngModel)]="customerDraft.website"/>
        </div>
        <div class="px-2 w-full mb-3">
          <label>Adresse</label>
          <input type="text" class="styled dark" [(ngModel)]="customerDraft.street"/>
        </div>
        <div class="px-2 w-full mb-3">
          <label>Adresszusatz</label>
          <input type="text" class="styled dark" [(ngModel)]="customerDraft.additionalAddress"/>
        </div>
        <div class="px-2 w-1/3 mb-3">
          <label>PLZ</label>
          <input type="text" class="styled dark" [(ngModel)]="customerDraft.zipCode"/>

        </div>
        <div class="px-2 w-2/3 mb-3">
          <label>Stadt</label>
          <input type="text" class="styled dark" [(ngModel)]="customerDraft.city"/>

        </div>
        <div class="px-2 w-full mb-3">
          <label>Land</label>
          <input type="text" class="styled dark" [(ngModel)]="customerDraft.country"/>
        </div>

        <div class="px-2 w-full mb-3">
          <label>Telefon (allgemein)</label>
          <input type="text" class="styled dark" [(ngModel)]="customerDraft.generalPhone"/>
        </div>

        <div class="px-2 w-full mb-3">
          <label>Email (allgemein)</label>
          <input type="text" class="styled dark" [(ngModel)]="customerDraft.generalEmail"/>
        </div>

        <div class="px-2 w-full mb-3">
          <label>Email-Domain</label>
          <input type="text" class="styled dark" [(ngModel)]="customerDraft.emailDomain"/>
        </div>

        <div class="px-2 w-full mb-3">
          <label>Kundenart</label>
          <select class="styled dark first" [(ngModel)]="customerDraft.customerType">
            <option value="client">Client</option>
            <option value="lead">Lead</option>
          </select>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Social Media">
      <div class="flex flex-wrap -mx-2">
        <div class="px-2 w-full mb-3">
          <label>Social Media</label>
          <div class="mb-1 w-full" *ngFor="let sm of customerDraft.socialMedia">
            <div class="w-full flex form-group">
              <div class="w-32">
                <select class="styled dark first" [(ngModel)]="sm.name">
                  <option value="instagram">Instagram</option>
                  <option value="youtube">Youtube</option>
                  <option value="tiktok">Tiktok</option>
                  <option value="twitter">Twitter</option>
                  <option value="facebook">Facebook</option>
                </select>
              </div>
              <div class="w-full">
                <input type="text" class="styled dark last" [(ngModel)]="sm.url"/>
              </div>
            </div>
            <a (click)="removeSocialMedia(sm)" class="text-sm cursor-pointer text-red-500 hover:underline">Entfernen</a>
          </div>

          <br>
          <div (click)="addSocialMedia()" matRipple
               class="py-2 px-3 inline-block text-center bg-blue-500 text-white rounded cursor-pointer">+ Hinzufügen
          </div>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Rechnungseinstellungen">
      <div class="flex flex-wrap -mx-2">
        <div class="px-2 w-full mb-3">
          <h3>Rechnungsadresse</h3>
          <div class="flex flex-wrap w-full -mx-1">
            <div class="w-1/2 px-1 mt-2">
              <label>Vorname</label>
              <input type="text" [(ngModel)]="customerDraft.billingAddress.firstName" class="styled dark"/>
            </div>
            <div class="w-1/2 px-1 mt-2">
              <label>Nachname</label>
              <input type="text" [(ngModel)]="customerDraft.billingAddress.lastName" class="styled dark"/>
            </div>
            <div class="w-full px-1 mt-2">
              <label>Firma</label>
              <input type="text" [(ngModel)]="customerDraft.billingAddress.companyName" class="styled dark"/>
            </div>
            <div class="w-full px-1 mt-2">
              <label>Straße/Nr.</label>
              <input type="text" [(ngModel)]="customerDraft.billingAddress.street" class="styled dark"/>
            </div>
            <div class="w-1/3 px-1 mt-2">
              <label>PLZ</label>
              <input type="text" [(ngModel)]="customerDraft.billingAddress.zipCode" class="styled dark"/>
            </div>
            <div class="w-2/3 px-1 mt-2">
              <label>Ort</label>
              <input type="text" [(ngModel)]="customerDraft.billingAddress.city" class="styled dark"/>
            </div>
            <div class="w-full px-1 mt-2">
              <label>Land</label>
              <input type="text" [(ngModel)]="customerDraft.billingAddress.country" class="styled dark"/>
            </div>
          </div>
        </div>
        <div class="px-2 w-full mb-3">
          <div class="flex flex-wrap w-full -mx-1">
            <div class="w-1/2 px-1 mt-2">
              <label>Zahlungsziel (in Tagen)</label>
              <input type="number" [(ngModel)]="customerDraft.timeForPayment" class="styled dark"/>
            </div>
            <div class="w-1/2 px-1 mt-2">
              <label>Kontakt auf Rechnung anzeigen</label><br>
              <mat-checkbox [checked]="customerDraft.showContactOnInvoice" (change)="customerDraft.showContactOnInvoice = !customerDraft.showContactOnInvoice">
                Aktiviert
              </mat-checkbox>
            </div>
            <div class="px-2 w-full mb-3">
              <label>Abrechnungsart</label>
              <select [(ngModel)]="customerDraft.accountingType" class="styled dark">
                <option [value]="null">Nicht überschreiben</option>
                <option [value]="'normal'">Zahlung an Artist</option>
                <option [value]="'settlement'">Zahlung an Lionflence</option>
              </select>
              <div class="text-sm text-gray-400">
                Achtung: Diese Einstellung überschreibt die Influencereinstellung bei einer Kooperation mit diesem Unternehmen.
              </div>
            </div>
            <div class="px-2 w-full mb-3">
              <label>Dieses Unternehmen erstellt Gutschriften</label><br>
              <mat-checkbox [checked]="customerDraft.createsCredits" (change)="customerDraft.createsCredits = !customerDraft.createsCredits">
                Aktiviert
              </mat-checkbox>
              <div class="text-sm text-gray-400">
                Ist diese Option aktiviert, werden Kooperationen mit diesem Unternehmen nicht im Rechnungssystem abrechenbar.
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
<div mat-dialog-close class="dialog-closer"></div>
<div mat-dialog-actions class="w-full text-right">
  <div class="w-full text-right">
    <app-button [loading]="(saving$ | async)" (click)="save()" classes="py-2 px-4 rounded bg-blue-500 text-white cursor-pointer inline-block">Speichern</app-button>
  </div>
</div>
